import api from "apiSingleton";
import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom-v5-compat";
import { useHistory, Link } from "react-router-dom";

const JobExternal = () => {
  const location = useLocation();
  const history = useHistory();
  const [state, setState] = useState({ loading: true, notFound: false });

  const queryParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );

  useEffect(() => {
    const fetchJob = async () => {
      try {
        setState((prevState) => ({ ...prevState, loading: true }));
        const sfdcExternalId = queryParams.get("sfdcexternalid");

        if (!sfdcExternalId) {
          setState((prevState) => ({
            ...prevState,
            loading: false,
            notFound: true,
          }));
          return;
        }

        const response = await api.jobs.getByExternalId({
          id: sfdcExternalId,
          source: "SFDC",
        });

        // If job is found, redirect to job details
        if (response && response.data && response.data.getJobOpportunityId) {
          history.push(`/jobOpps/${response.data.getJobOpportunityId}/details`);
        } else {
          setState((prevState) => ({ ...prevState, notFound: true }));
        }
      } catch (error) {
        console.error("Error fetching job:", error);

        setState((prevState) => ({ ...prevState, notFound: true }));
      } finally {
        setState((prevState) => ({ ...prevState, loading: false }));
      }
    };

    fetchJob();
  }, [queryParams, history]);

  if (state.loading) {
    return (
      <div
        className="flex justify-center pt-8"
        data-testid="job-external-loader"
      >
        <span className="loader"></span>
      </div>
    );
  }

  if (state.notFound) {
    return (
      <div
        className="flex items-center justify-center mt-32"
        data-testid="job-external-not-found"
      >
        <div className="text-center max-w-md mx-auto p-8">
          <div className="mb-6">
            <h1
              className="text-3xl font-bold text-gray-800 mb-2"
              data-testid="job-external-not-found-title"
            >
              Job not found
            </h1>
            <p className="text-lg text-gray-600 mb-6">
              We couldn't find the job opportunity you're looking for. It may
              have been removed or the link might be incorrect.
            </p>
          </div>

          <div className="space-y-4">
            <Link
              className="items-center max-w-full border rounded-full whitespace-nowrap transition-al bg-blue-500 text-white py-3 px-4 text-lg shadow-md hover:shadow-lg font-bold"
              to="/"
              data-testid="job-external-browse-all-link"
            >
              Browse all jobs
            </Link>
          </div>
        </div>
      </div>
    );
  }
  // Fallback
  return null;
};

export default JobExternal;
